module.exports = __webpack_public_path__ + "assets/img/title-e9b64ba6.png";